let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("kNFvF"), load("eILt2")]).then(() => parcelRequire('kiGd7'));